import React from "react";
import Background1 from "../../assets/images/breadcum/01.jpg";
import { Link } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";

export default function MandatoryDisclosure() {
  const [generalInformation, setGeneralInformation] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [resultsAndAcademics, setResultsAndAcademics] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [schoolInfraData, setSchoolInfraData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/api/auth/get/getAllGeneralinformation`
        );
        const sorted = (res.data || []).sort(
          (a, b) => (a.Order || 0) - (b.Order || 0)
        );
        setGeneralInformation(sorted);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/api/auth/AllDocAndinfo`
        );
        const sorted = (res.data || []).sort(
          (a, b) => (a.Order || 0) - (b.Order || 0)
        );
        setDocuments(sorted);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/api/auth/AllAcademic`
        );
        const sorted = (res.data || []).sort(
          (a, b) => (a.Order || 0) - (b.Order || 0)
        );
        setResultsAndAcademics(sorted);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/api/auth/StaffMaster`
        );
        const sorted = (res.data || []).sort(
          (a, b) => (a.Order || 0) - (b.Order || 0)
        );
        setStaffData(sorted);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/api/auth/list/Schoolinfra`
        );
        const sorted = (res.data || []).sort(
          (a, b) => (a.Order || 0) - (b.Order || 0)
        );
        setSchoolInfraData(sorted);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  const getPdfUrl = (filePath) => {
    if (!filePath) return "#";
    let normalized = filePath.replace(/\\/g, "/");
    if (normalized.startsWith("http://") || normalized.startsWith("https://")) {
      return normalized.replace(/\.pdf$/i, "");
    }
    const fileName = normalized.split("/").pop() || "";
    const cleanSlug = fileName.replace(/\.pdf$/i, "");
    const base = (process.env.REACT_APP_BASE_API_URL || "").replace(/\/+$/, "");
    return `${base}/${encodeURIComponent(cleanSlug)}`;
  };

  return (
    <>
      <section
        className="inner-banner bg-overlay-black-70 bg-holder"
        style={{ backgroundImage: `url(${Background1})` }}
      >
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-12">
              <div className="text-center">
                <h1 className="text-white">Mandatory Disclosure</h1>
              </div>
              <div className="d-flex justify-content-center ">
                <ol className="breadcrumb mb-0 p-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    <span>Mandatory Disclosure</span>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--about --> */}
      <section className="about-section space-ptb" style={{ background: "#fff" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div className="section-title mb-4">
                <h2 className="title">
                  Mandatory <span className="text-primary"> Disclosure</span>{" "}
                </h2>
                <div className="row mt-3">
                  <div className="col-md-12">
                    <div className="dynamic-disclosure">
                      <h4 style={{ fontWeight: 600 }} className="mb-4">
                        {" "}
                        General Information{" "}
                      </h4>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr className="text-uppercase">
                              <th>Sl. No.</th>
                              <th>Information</th>
                              <th>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            {generalInformation.map((info, index) => (
                              <tr key={index} className="text-uppercase">
                                <td>{index + 1}</td>
                                <td className="text-left">
                                  {info.Information}
                                </td>
                                <td>{info.Details}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-12">
                    <div className="dynamic-disclosure">
                      <h4 style={{ fontWeight: 600 }} className="mb-4">
                        {" "}
                        Documents and Information{" "}
                      </h4>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr className="text-uppercase">
                              <th>Sl.No.</th>
                              <th>Documents/Information</th>
                              <th>Upload Documents</th>
                            </tr>
                          </thead>
                          <tbody>
                            {documents.map((doc, index) => (
                              <tr key={index} className="text-uppercase">
                                <td>{index + 1}</td>
                                <td className="text-left">{doc.Title}</td>
                                <td>
                                  <a
                                    href={getPdfUrl(doc.File)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary text-white"
                                  >
                                    <i className="fa fa-download"></i>{" "}
                                    View/Download
                                  </a>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-12">
                    <div className="dynamic-disclosure">
                      <h4 style={{ fontWeight: 600 }} className="mb-4">
                        {" "}
                        Results and Academics{" "}
                      </h4>

                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr className="text-uppercase">
                              <th>Sl. No.</th>
                              <th>Documents/Information</th>
                              <th>Upload Documents</th>
                            </tr>
                          </thead>
                          <tbody>
                            {resultsAndAcademics.map((item, index) => (
                              <tr key={index} className="text-uppercase">
                                <td>{index + 1}</td>
                                <td className="text-left">{item.Title}</td>
                                <td>
                                  <a
                                    href={getPdfUrl(item.File)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary text-white"
                                  >
                                    <i className="fa fa-download"></i>{" "}
                                    View/Download
                                  </a>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-12">
                    <div className="dynamic-disclosure">
                      <h4 style={{ fontWeight: 600 }} className="mb-4">
                        {" "}
                        Staff (Teaching){" "}
                      </h4>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr className="text-uppercase">
                              <th>Sl. No.</th>
                              <th>Information</th>
                              <th>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            {staffData.map((item, index) => {
                              const subList =
                                item.subDetails &&
                                Array.isArray(item.subDetails) &&
                                item.subDetails.length > 0
                                  ? item.subDetails
                                  : [
                                      {
                                        subInfo: item.SubInfo1,
                                        subDetails: item.SubDetails1,
                                      },
                                      {
                                        subInfo: item.SubInfo2,
                                        subDetails: item.SubDetails2,
                                      },
                                      {
                                        subInfo: item.SubInfo3,
                                        subDetails: item.SubDetails3,
                                      },
                                    ].filter(
                                      (s) => s.subInfo || s.subDetails
                                    );

                              const hasSub =
                                (item.SubDetailsset || item.subDetailsset) &&
                                subList.length > 0;

                              return (
                                <React.Fragment key={index}>
                                  <tr className="text-uppercase">
                                    <td>{index + 1}</td>
                                    <td className="text-left">
                                      {item.Information}
                                    </td>
                                    <td>
                                      <div className="text-left">
                                        {item.Details}
                                      </div>
                                    </td>
                                  </tr>
                                  {hasSub &&
                                    subList.map((sub, sIdx) => (
                                      <tr
                                        key={`sub-${index}-${sIdx}`}
                                        className="text-uppercase"
                                        style={{ backgroundColor: "#f8f9fa" }}
                                      >
                                        <td></td>
                                        <td
                                          className="text-left text-secondary"
                                          style={{ paddingLeft: "35px", fontSize: "0.92em" }}
                                        >
                                          <i
                                            className="fa fa-angle-right me-2"
                                            style={{ color: "#039725", fontWeight: "bold" }}
                                          ></i>
                                          <span>{sub.subInfo}</span>
                                        </td>
                                        <td>
                                          <div
                                            className="text-left text-secondary fw-semibold"
                                            style={{ fontSize: "0.92em" }}
                                          >
                                            {sub.subDetails}
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-12">
                    <div className="dynamic-disclosure">
                      <h4 style={{ fontWeight: 600 }} className="mb-4">
                        {" "}
                        School Infrastructure{" "}
                      </h4>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr className="text-uppercase">
                              <th>Sl. No.</th>
                              <th>Information</th>
                              <th>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            {schoolInfraData &&
                              schoolInfraData.map((item, index) => (
                                <tr key={index} className="text-uppercase">
                                  <td>{index + 1}</td>
                                  <td className="text-left">
                                    {item.Information}
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {item.Details}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--about --> */}
    </>
  );
}
